import React, { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./StaffClientsModal.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { CommonMultiSelect, CommonSelect, CstmPagination, RequiredFieldAstrick } from "components/Common/Common";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { CloseIcon } from "Assets/icons";
import { Formik } from "formik";
import { APPOINTMENT_CLIENT_TYPE_OPTIONS, MIME_TYPES } from "config/constants";
import { useAssignConsentFormMutation, useLazyGetConsentFormsListQuery } from "store/services/guardian";
import { successMessageToast } from "helpers/common";
import { APPOINTMENT_FORMS_VIEW } from "config/paths";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import { cloneDeep } from "lodash";
import { useCreateReceiptsMutation } from "store/services/receipts";

const AddReceiptsModal = ({ show, setShow, parentId, clientId, clientType }) => {

    const {id} = useParams()
    const [initialValues, setInitialValues] = useState({ receipt: "" })
    const [createReceipt, { isLoading: assignConsentFormLoading }] = useCreateReceiptsMutation()

    const handlePopup = () => setShow(false)


    const handleSubmit = async (values) => {
        const body = {
            client_id: id,
            attachment_name: values?.receipt,
            attachment_key: values?.receipt
        }
        try {
            const result = await createReceipt(body).unwrap()
            successMessageToast(result?.message)
            setShow(false);
        } catch (error) {
            console.log("error assigning consent form", error)
        }
    }

    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <div onClick={handlePopup} style={{ display: "inline-block" }}>
                        <Button

                            className="cursor-pointer border-0 p-0 position-absolute"
                            variant="transparent"
                            style={{ right: 15, top: 10, cursor: "pointer", lineHeight: "0", verticalAlign: "middle" }}
                        >
                            <CloseIcon />
                        </Button>
                    </div>
                    <div>
                        <h6 className="m-0 fw-bold themeBlue">Add Receipt</h6>
                    </div>
                    <section
                        className={`${styles.ClientDetail} position-relative ClientDetail`}
                    >
                        <Container fluid>
                            <Row>
                                <Col
                                    lg="12"
                                    className=""
                                >
                                    <Row>
                                        <Col lg="12" className="my-3">
                                            <Formik
                                                initialValues={initialValues}
                                                // validationSchema={appointmentsValidationSchema}
                                                onSubmit={handleSubmit}
                                                enableReinitialize
                                            >
                                                {({
                                                    handleSubmit, values, setFieldValue, errors
                                                }) => (
                                                    <Form onSubmit={handleSubmit}>
                                                        <div
                                                            className="py-3"
                                                        //   style={{ borderTop: "1px solid #41a2a84d" }}
                                                        >
                                                            {console.log("FORMIK VALUES ", values)}
                                                            <Row>
                                                                {
                                                                    <Col md="12" sm="4" className="mt-2">
                                                                        <label className="form-label fw-bold themeBlue d-flex my-2">
                                                                            Receipt
                                                                            <RequiredFieldAstrick />
                                                                        </label>
                                                                        <AppFileUploadField
                                                                            name="receipt"
                                                                            acl={"private"}
                                                                            accept="image/*, application/pdf, .doc, .docx"
                                                                            allowedTypes={[MIME_TYPES.pdf, MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.webp, MIME_TYPES.doc, MIME_TYPES.docx]}
                                                                            className={`${styles.formControl} form-control`}
                                                                        // onChange={(name, value) => {
                                                                        //     handleAttachDocument(name, value, values, setFieldValue);
                                                                        // }}
                                                                        />
                                                                    </Col>
                                                                }


                                                            </Row>
                                                        </div>
                                                        <Row className="mt-4">
                                                            <Col className="my-2" lg="12">
                                                                <div
                                                                    className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                                                                    style={{ borderTop: "1px solid #41a2a84d" }}
                                                                >
                                                                    <Button type="submit" disabled={assignConsentFormLoading} className="d-flex align-items-center justify-content-center commonBtn">
                                                                        {assignConsentFormLoading ? <LoadingIndicator inline /> : "Save"}

                                                                    </Button>
                                                                    {/* <Button
                                                                          type="button"
                                                                          className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                                                                          onClick={() => navigate(MANAGE_PARENTS_LIST)}
                                                                        >
                                                                          Cancel
                                                                        </Button> */}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                        </Container>
                    </section>

                </Modal.Body>
            </Modal >
        </>
    );
};

export default AddReceiptsModal;